module.exports = __webpack_public_path__ + "static/media/Heart of the Frontier.01cf96a2.png";